import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { HomeDpPositions, DP_PAGE, LargeBanner, MiniBanner } from '@/types/home-newest';
import { getMultiLangAttr } from '@/business/home-newest';
import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';
import { getHomeBiExt } from '@/business/home-bi-helper';
import { cacheFunc } from '@tencent/wphk-base-utils';

const cacheQueryDpMessage = cacheFunc(queryDpMessage);

/**
 * 巨幕banner/胶囊banner筛选
 */
function LargeMiniBannerFilter(dpList: DpItem[] = []) {
  const largeBanner: DpItem[] = dpList.filter(item => item.dpPosition === HomeDpPositions.LargeBanner);
  const miniBanner: DpItem[] = dpList.filter(item => item.dpPosition === HomeDpPositions.MiniBanner);
  return {
    largeBanner,
    miniBanner,
  };
}

/**
 * 格式化巨幕banner
 */
function handleLargeBanner(data: DpItem[] = []): LargeBanner|null {
  const firstItem = data[0];
  if (firstItem) {
    const { img, url, countdown, backBtnColor } = firstItem.contentBaseData as any;
    return {
      img: getMultiLangAttr(img),
      url,
      id: firstItem.dpId,
      countdown,
      backBtnColor,
      reportInfo: getHomeBiExt(firstItem),
    };
  }
  return null;
}

/**
   * 格式化胶囊banner
   */
function handleMiniBanner(data: DpItem[] = []): MiniBanner|null {
  const firstItem = data[0];
  if (firstItem) {
    const { logo, img, url, btnText, type, desc, title } = firstItem.contentBaseData as any;
    return {
      logo,
      img: getMultiLangAttr(img),
      url,
      desc: getMultiLangAttr(desc),
      title: getMultiLangAttr(title),
      btnText: getMultiLangAttr(btnText),
      id: firstItem.dpId,
      type,
      reportInfo: getHomeBiExt(firstItem, {
        fmini_type: type,
      }),
    };
  }
  return null;
}

/**
 * 获取巨幕banner、胶囊banner数据
 */
export async function getLargeMiniBanner(cacheRes = false) {
  const dpMessageRes = await cacheQueryDpMessage({
    dpPage: DP_PAGE,
    dpPositions: [HomeDpPositions.LargeBanner, HomeDpPositions.MiniBanner],
  });
  const { largeBanner, miniBanner } = LargeMiniBannerFilter(dpMessageRes?.dpList);
  // 是否需要缓存请求结果
  if (!cacheRes) {
    cacheQueryDpMessage.clearCache();
  };
  return {
    largeBanner: handleLargeBanner(largeBanner),
    miniBanner: handleMiniBanner(miniBanner),
  };
}
